import React from "react";
import { Icons } from "assets/icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const CustomCheckbox = ({
  label = "",
  checked = false,
  onChange = () => {},
  disabled = false,
  className = "",
  infoText = null,
}) => {
  const { checkWhite, info } = Icons || {};

  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <div
      className={`custom_checkbox ${disabled ? "disabled" : ""} ${className}`}
      onClick={handleToggle}
      role="checkbox"
      aria-checked={checked}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleToggle();
        }
      }}
    >
      <div className={`checkbox ${checked ? "checked" : ""}`}>
        {checked && (
          <img src={checkWhite} alt="checked" width={10} height={10} />
        )}
      </div>

      {label && (
        <span className="checkbox_label">
          {label}{" "}
          {infoText && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>{infoText}</Tooltip>}
            >
              <img
                src={info}
                alt="info"
                width={15}
                height={15}
                style={{
                  cursor: "pointer",
                  marginBottom: 2,
                  marginInlineStart: 5,
                }}
              />
            </OverlayTrigger>
          )}
        </span>
      )}
    </div>
  );
};

export default CustomCheckbox;
